import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';
import { useSessionStore } from '@hub/hooks/states/useSessionStore';
import { useFeatureFlag } from '@hub/libs/abby/abby';
import { memo } from 'react';

export const CAD_SEARCH_BUTTON_ID = 'cad-search-button-placeholder';

const CadSearchButton = memo(() => {
  const showCadSearchButton = useFeatureFlag('showCadSearchButton');
  const { session } = useSessionStore();
  return showCadSearchButton ? (
    <button
      id={CAD_SEARCH_BUTTON_ID}
      className="flex justify-center items-center  w-16 h-16 ml-12 border-[#D8D8D8] border-[0.75px] rounded-full shadow-[0px_2px_7px_0px_#00000040]"
      type="button"
      aria-label="CAD Search Button"
      data-session-country={session?.country}
      data-session-language={session?.language}
      style={{ visibility: 'hidden' }}
    >
      <Icon size={7} color={IconColor.MID_GRAY} id={IconID.CAD_FILES} />
    </button>
  ) : null;
});

export { CadSearchButton };
